import React from 'react';
import PrimaryButtonLink from '../components/PrimaryButtonLink';
import PageSection from '../components/PageSection';

const MetodoHelpy = () => {
  return (
    <>
      <section className="hero hero-secondary">
        <div className="container hero-inner">
          <p className="eyebrow">Il Metodo HelpSoftware</p>
          <h1>Come funziona la tua IT liquida, dal board all'operativo.</h1>
          <p className="hero-subtitle">
            Il nostro modello non e body rental: e un'estensione intelligente
            della tua azienda, basata su elasticita, governance e risultato.
          </p>
          <div className="hero-actions">
            <PrimaryButtonLink to="/contatti">
              Parla con un PM dedicato
            </PrimaryButtonLink>
            <PrimaryButtonLink to="/talent-strategy" variant="ghost">
              Vedi il confronto RaaS
            </PrimaryButtonLink>
          </div>
        </div>
      </section>

      <PageSection title="I tre pilastri del metodo">
        <div className="pillar-grid">
          <article className="pillar-card">
            <h3>Elasticita</h3>
            <p>
              Scalabilita immediata in base al carico reale, senza vincoli o
              tempi morti.
            </p>
          </article>
          <article className="pillar-card">
            <h3>Governance</h3>
            <p>
              Un PM dedicato coordina output, qualita e allineamento agli
              standard.
            </p>
          </article>
          <article className="pillar-card">
            <h3>Risultato</h3>
            <p>
              Ogni euro investito si traduce in milestone certificate e visibili
              in dashboard.
            </p>
          </article>
        </div>
      </PageSection>

      <PageSection title="1. Project Manager dedicato: la tua unica interfaccia">
        <div className="method-card">
          <p>
            A differenza dei modelli tradizionali, con noi hai un PM di
            riferimento (single point of contact). Non e solo un coordinatore,
            ma un esperto tecnico-strategico che:
          </p>
          <ul>
            <li>Traduce obiettivi di business in task operativi.</li>
            <li>Garantisce standard di qualita e delivery continuo.</li>
            <li>Ti solleva dal micro-management quotidiano.</li>
          </ul>
        </div>
      </PageSection>

      <PageSection title="2. Scalabilita on-demand (come il cloud)">
        <div className="method-grid">
          <article className="method-card">
            <h3>Fase di acceleration</h3>
            <p>
              Serve una feature in 4 settimane? Incrementiamo risorse (Dev,
              UI/UX, QA) in modo istantaneo.
            </p>
          </article>
          <article className="method-card">
            <h3>Fase di maintenance</h3>
            <p>
              Progetto stabile? Riduciamo l'extra per ottimizzare il budget
              (OPEX).
            </p>
          </article>
          <article className="method-card">
            <h3>Nessun vincolo</h3>
            <p>
              Paghi per cio che consumi, come le istanze AWS: solo valore reale.
            </p>
          </article>
        </div>
      </PageSection>

      <PageSection title="3. Framework operativo: da idea a deploy">
        <div className="comparison-table-card">
          <table className="comparison-table framework-table">
            <thead>
              <tr>
                <th>Fase</th>
                <th>Cosa succede</th>
                <th className="highlight">Ruolo del PM HelpSoftware</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Assessment</strong></td>
                <td>Analisi del gap tecnologico e definizione del team ideale.</td>
                <td className="highlight">Definisce lo stack e le skill necessarie.</td>
              </tr>
              <tr>
                <td><strong>Plug-in</strong></td>
                <td>Le risorse as-a-service entrano nei tuoi flussi (Slack, Jira, Git).</td>
                <td className="highlight">Onboarding rapido e allineamento agli standard.</td>
              </tr>
              <tr>
                <td><strong>Execution</strong></td>
                <td>Sviluppo agile con sprint settimanali.</td>
                <td className="highlight">Monitora velocita (velocity) e qualita del codice.</td>
              </tr>
              <tr>
                <td><strong>Optimization</strong></td>
                <td>Review performance e scalabilita del team (up/down).</td>
                <td className="highlight">Gestisce aggiunta o rimozione di risorse.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </PageSection>

      <PageSection title="Perche e board-ready">
        <div className="method-card">
          <ul>
            <li>
              Eliminazione dei costi di ricerca HR: talenti gia pronti e testati.
            </li>
            <li>
              Trasferimento del rischio: sostituzione immediata senza perdita di
              conoscenza.
            </li>
            <li>
              Controllo totale del TCO: budget legato a output tracciabili.
            </li>
          </ul>
          <p>
            In sintesi: HelpSoftware offre la potenza di un grande dipartimento
            IT con la flessibilita di una startup. Tu metti la visione, noi
            mettiamo i muscoli e il cervello.
          </p>
        </div>
      </PageSection>

      <PageSection title="Pronti a partire?">
        <div className="cta-panel">
          <div>
            <h3>Attiviamo il tuo PM dedicato</h3>
            <p>
              Costruiamo insieme il piano operativo e le metriche da condividere
              con il board.
            </p>
          </div>
          <div className="hero-actions">
            <PrimaryButtonLink to="/contatti">Prenota una call</PrimaryButtonLink>
            <PrimaryButtonLink to="/raas" variant="ghost">
              Richiedi una demo
            </PrimaryButtonLink>
          </div>
        </div>
      </PageSection>
    </>
  );
};

export default MetodoHelpy;
